'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useCallHistory } from './CallHistoryProvider';
/** Chronological event list. Click a row to expand its payload. */
export function EventFeed({ nodeLabel }) {
    const { callEvents: entries } = useCallHistory();
    const scrollRef = useRef(null);
    const [expanded, setExpanded] = useState(new Set());
    const label = nodeLabel ?? defaultLabel;
    useEffect(() => {
        const node = scrollRef.current;
        if (node)
            node.scrollTop = node.scrollHeight;
    }, [entries]);
    const toggle = (key) => {
        setExpanded(prev => {
            const next = new Set(prev);
            if (next.has(key))
                next.delete(key);
            else
                next.add(key);
            return next;
        });
    };
    return (_jsxs("div", { className: "flex h-full min-h-0 min-w-0 flex-col gap-2", children: [_jsx("div", { className: "text-sm font-medium", children: "Events" }), _jsx("div", { ref: scrollRef, className: "flex-1 min-h-0 divide-y divide-border/60 overflow-y-auto rounded-md border border-border bg-muted/20 px-3 py-2 text-xs", children: entries.length === 0 ? (_jsx("div", { className: "text-xs text-muted-foreground", children: "Waiting for the first event\u2026" })) : (entries.map((entry, idx) => {
                    const key = rowKey(entry, idx);
                    const isOpen = expanded.has(key);
                    return (_jsx("div", { className: idx === 0 ? 'pb-3' : 'py-3 last:pb-0', children: _jsx(EventRow, { entry: entry, label: label, isOpen: isOpen, onToggle: () => toggle(key) }) }, key));
                })) })] }));
}
function EventRow({ entry, label, isOpen, onToggle, }) {
    const hasPayload = entry.parameters !== undefined && Object.keys(entry.parameters).length > 0;
    return (_jsxs("div", { children: [_jsxs("button", { type: "button", onClick: onToggle, className: "flex w-full items-baseline justify-between gap-3 text-left", children: [_jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("div", { className: "truncate font-medium leading-tight", children: entry.eventType }), _jsxs("div", { className: "mt-1 truncate text-[10px] uppercase tracking-wide text-muted-foreground", children: [entry.source, " \u00B7 ", label(entry.node), " \u00B7 turn ", entry.turnIndex] })] }), _jsxs("div", { className: "shrink-0 tabular-nums text-[10px] text-muted-foreground", children: [timeLabel(entry.timestamp), hasPayload && (_jsx("span", { className: "ml-1 inline-block", children: isOpen ? '▾' : '▸' }))] })] }), isOpen && hasPayload && (_jsx("pre", { className: "mt-2 overflow-x-auto rounded border border-border/60 bg-background/60 p-2 text-[11px] leading-snug", children: JSON.stringify(entry.parameters, null, 2) }))] }));
}
function defaultLabel(id) {
    if (!id)
        return '—';
    return id;
}
function timeLabel(iso) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return '';
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
}
function rowKey(entry, idx) {
    return `${entry.timestamp}-${entry.turnIndex}-${entry.eventType}-${idx}`;
}
//# sourceMappingURL=EventFeed.js.map